import { useState } from 'react';
import '../App.css';
import { CiClock2 } from 'react-icons/ci';
import { BsBarChartLine, BsCartFill } from 'react-icons/bs';
import { PiTargetBold } from 'react-icons/pi';
import { BsPersonSquare } from 'react-icons/bs';
import { FaRegCircleXmark } from 'react-icons/fa6';
import CategoryIcon from '@mui/icons-material/Category';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import TRC_CONTENT from '@/constants/trcContentType';
import { durationOptions } from '@/component/FilterFunction/getAvailableDuration';
import { DurationPills } from '@/component/DurationPills';
import useResize from '@/Pages/VideoPlayer/hooks/useResize';


const FilterModal = ({
	isOpen,
	tags,
	durationValue,
	checkedTags,
	checkedDuration,
	checkedLevels,
	handleApplyFilter,
	handleClose,
	checkedInstructors,
	instructors,
	products,
	checkedProducts,
	showDurationFilter = true,
	showLevelFilter = true,
	contentType = TRC_CONTENT.VIDEO,
	categories = [],
	checkedCategories = [],
	showCategoryFilter = false,
	showInstructorFilter = true,
	showEquipmentFilter = true,
}) => {

	const levels = [
		{ label: 'Beginner', value: 'Beginner' },
		{ label: 'Intermediate', value: 'Intermediate' },
		{ label: 'Advanced', value: 'Advanced' }
	];

	const deviceType = useResize();
	const isMobile = deviceType === 'mobile';

	const [selectedTags, setSelectedTags] = useState(checkedTags || []);
	const [selectedDurations, setSelectedDurations] = useState(checkedDuration || []);
	const [selectedLevels, setSelectedLevels] = useState(checkedLevels || []);
	const [selectedInstructors, setSelectedInstructors] = useState(checkedInstructors || []);
	const [selectedProducts, setSelectedProducts] = useState(checkedProducts || []);
	const [selectedCategories, setSelectedCategories] = useState(checkedCategories || []);

	const handleTagChange = tagId => {
		setSelectedTags(prevTags =>
			prevTags.includes(tagId) ? prevTags.filter(prevTag => prevTag !== tagId) : [...prevTags, tagId]
		);

		setSelectedTags(updatedTags => {
			return updatedTags; // Make sure to return the updated value
		});
	};

	const handleInstructorChange = instructorName => {
		setSelectedInstructors(prevInstructors =>
			prevInstructors.includes(instructorName)
				? prevInstructors.filter(prevInstructor => prevInstructor !== instructorName)
				: [...prevInstructors, instructorName]
		);
	};

	const handleDurationChange = durationValue => {
		setSelectedDurations(prevDurations =>
			prevDurations.includes(durationValue)
				? prevDurations.filter(prevDuration => prevDuration !== durationValue)
				: [...prevDurations, durationValue]
		);
	};

	const handleLevelChange = levelValue => {
		setSelectedLevels(prevLevels =>
			prevLevels.includes(levelValue)
				? prevLevels.filter(prevLevel => prevLevel !== levelValue)
				: [...prevLevels, levelValue]
		);
	};

	const handleCategoryChange = categoryId => {
		setSelectedCategories(prevCategories =>
			prevCategories.includes(categoryId)
				? prevCategories.filter(prevCategory => prevCategory !== categoryId)
				: [...prevCategories, categoryId]
		);
	};

	const handleProductChange = product => {

		const productKey = product.subname && product.subname.trim() !== '' ? product.subname : product.name;

		if (!productKey) {
			console.warn('Invalid product selection, missing both subname and name:', product);
			return;
		}

		setSelectedProducts(prevProducts =>
			prevProducts.includes(productKey)
				? prevProducts.filter(prevProduct => prevProduct !== productKey)
				: [...prevProducts, productKey]
		);
	};
	const handleResetFilter = () => {
		setSelectedTags([]);
		setSelectedDurations([]);
		setSelectedLevels([]);
		setSelectedInstructors([]);
		setSelectedProducts([]);
		setSelectedCategories([]);
	};
	const handleApplyFilters = () => {
		handleApplyFilter(selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts, selectedCategories);
	};

	const [open, setOpen] = useState({
		duration: true,
		tags: true,
		levels: true,
		instructors: true,
		products: true,
		categories: true
	});
	const iconColor = '#008bc3';

	return (
		<div >
			<div className="c-modal-overlay" style={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				background: "rgba(0, 0, 0, 0.5)",
				zIndex: 999
			}} >
				<div className={`c-tag ${contentType === TRC_CONTENT.TRC && !isMobile ? "fixed-tag" : ""
					}`}
				>
					<div className="c-tag_pop">
						<div>
							<div className="c-tag_pop-header">
								<h2>Filters</h2>
								<a onClick={handleClose}>
									<FaRegCircleXmark color="white" />
								</a>
							</div>
							<div className="c-tag_body-m">
								<div className="c-tag_body">
									{/* Duration Filter */}
									{showDurationFilter && (
										<div className="c-tag_body_one">
											<div
												className="c-tag_body_head"
												onClick={() =>
													setOpen(prev => ({
														...prev,
														duration: !prev.duration
													}))
												}
											>
												<div className="c-tag_filter_head">
													<CiClock2 size={20} />
													Duration
													<div>
														{selectedDurations.length > 0 && (
															<div className="c-tag_count">{selectedDurations.length}</div>
														)}
													</div>
												</div>
												<div className="c-tag_resize_icon">
													{open.duration ? (
														<RemoveIcon sx={{ color: iconColor }} />
													) : (
														<AddIcon sx={{ color: iconColor }} />
													)}
												</div>
											</div>

											<DurationPills
												show={Boolean(open?.duration)}
												options={contentType === TRC_CONTENT.TRC ? durationValue : durationOptions}
												selected={selectedDurations}
												onToggle={handleDurationChange}
											/>
										</div>
									)}



									{/* Focus Filter */}
									<div className="c-tag_body_one">
										<div
											className="c-tag_body_head"
											onClick={() =>
												setOpen(prev => ({
													...prev,
													tags: !prev.tags
												}))
											}
										>
											<div className="c-tag_filter_head ">
												<PiTargetBold size={20} />
												Focus
												<div>{selectedTags.length > 0 && <div className="c-tag_count">{selectedTags.length}</div>}</div>
											</div>
											<div className="c-tag_resize_icon">
												{open.tags ? <RemoveIcon sx={{ color: iconColor }} /> : <AddIcon sx={{ color: iconColor }} />}
											</div>
										</div>
										{open.tags && (
											<div className="c-tag_body_from">
												{tags?.map(tag => (
													<div
														className={`c-tag_body_from-input ${selectedTags.includes(tag._id) ? 'selected' : ''}`}
														key={tag._id}
														onClick={() => handleTagChange(tag._id)}
													>
														{tag.name}
													</div>
												))}
											</div>
										)}
									</div>
									{showLevelFilter && (
										<div className="c-tag_body_one">
											<div
												className="c-tag_body_head"
												onClick={() =>
													setOpen(prev => ({
														...prev,
														levels: !prev.levels
													}))
												}
											>
												<div className="c-tag_filter_head">
													<BsBarChartLine size={20} />
													Levels
													<div>
														{selectedLevels.length > 0 && <div className="c-tag_count">{selectedLevels.length}</div>}
													</div>
												</div>
												<div className="c-tag_resize_icon">
													{open.levels ? <RemoveIcon sx={{ color: iconColor }} /> : <AddIcon sx={{ color: iconColor }} />}
												</div>
											</div>
											{open.levels && (
												<div className="c-tag_body_from">
													{levels?.map(level => (
														<div
															className={`c-tag_body_from-input ${selectedLevels.includes(level.value) ? 'selected' : ''}`}
															key={level.value}
															onClick={() => handleLevelChange(level.value)}
														>
															{level.label}
														</div>
													))}
												</div>
											)}
										</div>
									)}

									{/* Category Filter */}
									{showCategoryFilter && (
										<div className="c-tag_body_one">
											<div
												className="c-tag_body_head"
												onClick={() =>
													setOpen(prev => ({
														...prev,
														categories: !prev.categories
													}))
												}
											>
												<div className="c-tag_filter_head">
													<CategoryIcon size={20} />
													Categories
													<div>
														{selectedCategories.length > 0 && (
															<div className="c-tag_count">{selectedCategories.length}</div>
														)}
													</div>
												</div>
												<div className="c-tag_resize_icon">
													{open.categories ? (
														<RemoveIcon sx={{ color: iconColor }} />
													) : (
														<AddIcon sx={{ color: iconColor }} />
													)}
												</div>
											</div>
											{open.categories && (
												<div className="c-tag_body_from">
													{categories?.length > 0 ? (
														categories.map(category => (
															<div
																className={`c-tag_body_from-input ${selectedCategories.includes(category._id) ? 'selected' : ''}`}
																key={category._id}
																onClick={() => handleCategoryChange(category._id)}
															>
																{category.name}
															</div>
														))
													) : (
														<p>No Categories Found</p>
													)}
												</div>
											)}
										</div>
									)}

									{/* Instructors Filter */}
									{showInstructorFilter && (
										<div className="c-tag_body_one">
											<div
												className="c-tag_body_head"
												onClick={() =>
													setOpen(prev => ({
														...prev,
														instructors: !prev.instructors
													}))
												}
											>
												<div className="c-tag_filter_head">
													<BsPersonSquare size={20} />
													Instructors
													<div>
														{selectedInstructors.length > 0 && (
															<div className="c-tag_count">{selectedInstructors.length}</div>
														)}
													</div>
												</div>
												<div className="c-tag_resize_icon">
													{open.instructors ? (
														<RemoveIcon sx={{ color: iconColor }} />
													) : (
														<AddIcon sx={{ color: iconColor }} />
													)}
												</div>
											</div>
											{open.instructors && (
												<div className="c-tag_body_from">
													{instructors?.length > 0 ? (
														instructors.map(instructor => (
															<div
																className={`c-tag_body_from-input ${selectedInstructors.includes(instructor) ? 'selected' : ''
																	}`}
																key={instructor}
																onClick={() => handleInstructorChange(instructor)}
															>
																{instructor}
															</div>
														))
													) : (
														<p>No Instructor Found</p>
													)}
												</div>
											)}
										</div>
									)}

									{/* Products Filter */}
									{showEquipmentFilter && (
										<div className="c-tag_body_one">
											<div
												className="c-tag_body_head"
												onClick={() =>
													setOpen(prev => ({
														...prev,
														products: !prev.products
													}))
												}
											>
												<div className="c-tag_filter_head">
													<FitnessCenterIcon size={20} />
													Equipment
													<div>
														{selectedProducts.length > 0 && <div className="c-tag_count">{selectedProducts.length}</div>}
													</div>
												</div>
												<div className="c-tag_resize_icon">
													{open.products ? <RemoveIcon sx={{ color: iconColor }} /> : <AddIcon sx={{ color: iconColor }} />}
												</div>
											</div>
											{open.products && (
												<div className="c-tag_body_from">
													{products?.length > 0 ? (
														products.map(product => (
															<div
																className={`c-tag_body_from-input ${selectedProducts.includes(product.subname || product.name) ? 'selected' : ''
																	}`}
																key={product.id}
																onClick={() => handleProductChange(product)}
															>
																{product.subname || product.name}
															</div>
														))
													) : (
														<p>No Products Found</p>
													)}
												</div>
											)}
										</div>
									)}
								</div>

								<div className="c-tag_btn">
									<div className="c-tag_btn-box">
										<button onClick={handleResetFilter} className="c-tag_btn-reset">
											reset
										</button>
										<button onClick={handleApplyFilters} className="c-tag_btn-apply">
											apply
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div >
		</div>
	);
};

export default FilterModal;
